"use strict";
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (Object.hasOwnProperty.call(mod, k)) result[k] = mod[k];
    result["default"] = mod;
    return result;
};
Object.defineProperty(exports, "__esModule", { value: true });
const react_1 = __importStar(require("react"));
const reactstrap_1 = require("reactstrap");
const TableGroupModal_1 = require("../../modals/TableGroupModal");
exports.TableGroups = ({ selected = [], handleGroupsChange, tableGroups, }) => {
    const [modal, setModal] = react_1.useState(false);
    const toggleGroupsModal = () => {
        setModal(!modal);
    };
    return (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(reactstrap_1.Button, { color: "primary", size: "sm", onClick: toggleGroupsModal }, "Groups"),
        modal && (react_1.default.createElement(TableGroupModal_1.TableGroupModal, { isOpen: modal, selectedGroups: selected, tableGroups: tableGroups, onSave: handleGroupsChange, onToggle: toggleGroupsModal }))));
};
//# sourceMappingURL=TableGroups.js.map